const Index = () => import(/* webpackChunkName: "manager" */ './Index');
const Personal = () => import(/* webpackChunkName: "personal" */ './Personal');

export default {
  routes: [
    {
      path: '/ol-ctra/index',
      name: 'ol_ctra_index',
      component: Index
    },
    {
      path: '/ol-ctra/personal',
      name: 'ol_ctra_personal',
      component: Personal
    }
  ]
}
